import React from 'react';
import PropTypes from 'prop-types';

const ModalContext = React.createContext(null);
export default ModalContext;

export const ModalContextPropType = PropTypes.shape({
  /**
   * Function which accepts a modal instance and, optionally, an `onRemove` callback, and returns
   * the ID of the modal that was added to the context.
   */
  add: PropTypes.func.isRequired,
  /**
   * Given a modal ID generated by the same context, removes the modal from the context.
   */
  remove: PropTypes.func.isRequired,
});

/**
 * Provides a programmatic way of opening a modal given a modal context.
 * @param {Function} renderModal Given a function which can be used to close the modal, returns the
 * rendered modal.
 * @param {Object} modalContext A modal context which matches the signature of
 * `ModalContextPropType`
 * @param {Function} [onRemove] A function to be called when the modal rendered begins closing
 * @returns {Number} The ID of the modal that was rendered.
 */
export function renderModalInContext(renderModal, modalContext, onRemove) {
  let modalId;
  const closeModal = () => modalContext.remove(modalId);
  modalId = modalContext.add(renderModal(closeModal), onRemove);
  return modalId;
}
